import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { MEAL_LABELS } from "@/lib/api";
import { DAY_NAMES_FULL, formatDate, dateToKey } from "@/lib/weeklyPlanUtils";

export default function MoveMealDialog({
  movePickerSrc,
  onClose,
  targets,
  getContent,
  getSlot,
  setSlot,
  buildMealOrder,
}) {
  return (
    <Dialog open={!!movePickerSrc} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="move-meal-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "'Cormorant Garamond', serif" }}>Flytt måltid</DialogTitle>
          <DialogDescription>
            {movePickerSrc ? `${getContent(movePickerSrc.date, movePickerSrc.meal) || ""} → velg ny dag og måltid` : ""}
          </DialogDescription>
        </DialogHeader>
        {movePickerSrc && (
          <div className="space-y-2 max-h-[60vh] overflow-y-auto">
            {targets.map((d) => (
              <div key={dateToKey(d)} className="border border-stone-100 rounded-lg p-2">
                <div className="text-xs font-semibold text-stone-600 mb-1.5">
                  {DAY_NAMES_FULL[d.getDay()]} {formatDate(d)}
                </div>
                <div className="grid grid-cols-2 gap-1.5">
                  {buildMealOrder(d).map((entry) => {
                    const m = entry.key;
                    const tgtKey = `${dateToKey(d)}|${m}`;
                    const srcKey = `${dateToKey(movePickerSrc.date)}|${movePickerSrc.meal}`;
                    const isSame = tgtKey === srcKey;
                    const tgtContent = getContent(d, m);
                    const label = entry.type === "extra" ? entry.name : MEAL_LABELS[m];
                    return (
                      <button
                        key={m}
                        disabled={isSame}
                        onClick={() => {
                          const src = movePickerSrc;
                          const srcSlot = getSlot(src.date, src.meal);
                          const dstSlot = getSlot(d, m);
                          setSlot(d, m, srcSlot);
                          setSlot(src.date, src.meal, dstSlot || { recipe_id: null, recipe_title: "", custom_meal: "" });
                          onClose();
                          toast.success("Måltid flyttet");
                        }}
                        className={`text-left px-2 py-1.5 rounded-md text-xs border transition-colors ${isSame ? "border-stone-100 bg-stone-50 text-stone-300 cursor-not-allowed" : "border-stone-200 bg-white text-stone-700 hover:bg-sailcloth-100 hover:border-navy-200"}`}
                        data-testid={`move-target-${tgtKey}`}
                      >
                        <div className="text-[10px] uppercase tracking-wider font-semibold text-stone-400">{label}</div>
                        <div className="truncate font-medium">
                          {isSame ? "(her nå)" : tgtContent || <span className="text-stone-400">— tom —</span>}
                        </div>
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
